import React from "react";
import * as Styled from "./ManageContentBlocks.styled";
import { TemplateCard } from "../../template-card";
import { BlockWithInfo, TemplateBlockType } from "../../../../libs/models/manage-template";

export const ManageContentBlocks: React.FC<{
    order: BlockWithInfo[];
    blocks: BlockWithInfo[];
    updateOrder?: (order: BlockWithInfo[]) => void;
}> = ({ order, blocks, updateOrder }) => {
    return (
        <Styled.ContentWrapper>
            <Styled.ContentBlockRow>
                <Styled.ContentHeader>Content Blocks</Styled.ContentHeader>
                {blocks.map((block) => {
                    if (block.blockType === TemplateBlockType.PLAYLIST) return null;
                    return (<Styled.ContentBlockCol xs={12} sm={6} md={6} lg={6} key={block.blockId}>
                        <TemplateCard
                            title={block.title}
                            subtitle={""}
                            svgSrc={block.svgSrc}
                            onClick={() => console.log(`${block.title} clicked`)}
                            showToggle={true}
                            toggleValue={order.find((o) => o.blockId === block.blockId) ? true : false}
                            onToggle={(value) => {
                                if (updateOrder) {
                                    const newOrder = value
                                        ? [...order, block]
                                        : order.filter((o) => o.blockId !== block.blockId);
                                    updateOrder(newOrder);
                                }
                            }}
                            showChevron={false}
                        />
                    </Styled.ContentBlockCol>)
                })}
            </Styled.ContentBlockRow>
            <Styled.ContentBlockRow>
                <Styled.ContentHeader>Playlist Blocks</Styled.ContentHeader>
                {blocks.map((block) => {
                    if (block.blockType !== TemplateBlockType.PLAYLIST) return null;
                    return (
                        <Styled.ContentBlockCol xs={12} sm={6} md={6} lg={6} key={block.blockId}>
                            <TemplateCard
                                title={block.title}
                                subtitle={""}
                                svgSrc={block.svgSrc}
                                onClick={() => console.log(`${block.title} clicked`)}
                                showToggle={true}
                                toggleValue={order.find((o) => o.blockId === block.blockId) ? true : false}
                                onToggle={(value) => {
                                    if (updateOrder) {
                                        const newOrder = value
                                            ? [...order, block]
                                            : order.filter((o) => o.blockId !== block.blockId);
                                        updateOrder(newOrder);
                                    }
                                }}
                                showChevron={false}
                            />
                        </Styled.ContentBlockCol>
                    );
                })}
            </Styled.ContentBlockRow>
        </Styled.ContentWrapper>
    );
}
